import { render, staticRenderFns } from "./ProposalRouterView.vue?vue&type=template&id=2f0bbd86&"
import script from "./ProposalRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports